module.exports = __webpack_public_path__ + "c.no1.6fac1acf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/c.no1.jpg
// module id = LuU2
// module chunks = 0